export default __webpack_public_path__ + "static/media/Path3405.4e2c5095.svg";